import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import useTranslate from "../../hooks/useTranslate";
import { colorRed } from "../../constants/colors";
import CustomButton from "../CustomButton/CustomButton";
import { IAlertDialogProps } from "./AlertDialogTripleChoice.props";

const AlertDialog = ({
	showAlertDialog,
	setShowAlertDialog,
	submitHandler,
	accompanyingHandler,
	closeHandler,
	title,
	description,
	name,
	name2,
}: IAlertDialogProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	// закрываем диалоговое окно
	const closeAlertDialog = (): void => {
		setShowAlertDialog && setShowAlertDialog(false);
	};

	// обработчик нажатия клавиши
	// const keyDownHandler = (e: React.KeyboardEvent<HTMLDivElement>): void => {
	// e.code === 'Enter' && submitHandler('questions');
	// };

	return (
		<Dialog
			open={showAlertDialog}
			onClose={closeHandler || closeAlertDialog}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			// onKeyDown={(e) => keyDownHandler(e)}
		>
			<DialogTitle id="alert-dialog-title" color={colorRed} sx={{ fontSize: 16 }}>
				{translate(title)} {name && `"${name}"`} {name2 && `${translate("dialog_onTitle")} "${name2}"`}
			</DialogTitle>
			<DialogContent sx={{ paddingBottom: 2 }}>
				<DialogContentText id="alert-dialog-description" sx={{ fontSize: 13 }}>
					{translate(description)}
				</DialogContentText>
			</DialogContent>
			<DialogActions sx={{ paddingTop: 0 }}>
				<CustomButton variant="text" onClick={closeHandler || closeAlertDialog}>
					{translate("button_cancellation")}
				</CustomButton>
				<CustomButton
					variant="text"
					color="error"
					onClick={() => {
						submitHandler("answers");
						accompanyingHandler();
					}}
				>
					{translate("button_deleteOnlyAnswers")}
				</CustomButton>
				<CustomButton
					variant="text"
					color="error"
					onClick={() => {
						submitHandler("questions");
						accompanyingHandler();
					}}
				>
					{translate("button_deleteQuestions")}
				</CustomButton>
			</DialogActions>
		</Dialog>
	);
};

export default AlertDialog;
